var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wf-alert",attrs:{"data-deliver-part":"VC11028"}},[_c('v-alert',_vm._b({staticClass:"wf-alert__alert"},'v-alert',_vm.alertAttrs,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.alertContents)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }